var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 894,
    height: 894,
    viewBox: "0 0 894 894",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "circles"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "largeCircle",
    cx: 447,
    cy: 447,
    r: 445,
    fill: "none",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "middleCircle",
    cx: 447,
    cy: 447,
    r: 369,
    fill: "none",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "innerSmallCircle",
    cx: 447,
    cy: 447,
    r: 310,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "smallCircle",
    cx: 447,
    cy: 447,
    r: 305,
    fill: "none",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "chart",
    transform: "translate(447, 447)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12491D",
    d: "M1.687387502250017,-244.36917430072324A244.375,244.375,0,0,1,77.75058099237341,-231.67647222009484L25.795078400185165,-80.33526346087564A84.375,84.375,0,0,0,1.6873875022499853,-84.3581255624925Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12491D",
    d: "M80.94250137848987,-230.5806845674485A244.375,244.375,0,0,1,148.76306761190682,-193.87802954356442L50.48224730607947,-67.60682903322586A84.375,84.375,0,0,0,28.986998786301562,-79.23947580822927Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA131",
    d: "M151.42623927805613,-191.8051998333332A244.375,244.375,0,0,1,203.65476755886405,-135.06989403840169L69.6988814035856,-47.552145651788514A84.375,84.375,0,0,0,53.14541897222879,-65.53399932299466Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA131",
    d: "M205.5005945316529,-132.24464553295607A244.375,244.375,0,0,1,236.47731341151055,-61.624839688831734L81.36256021143852,-22.34444944141701A84.375,84.375,0,0,0,71.54470837637446,-44.72689714634287Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DA131",
    d: "M237.30577169748082,-58.35333190198407A244.375,244.375,0,0,1,243.6738730324388,18.498222248932432L84.20934315018359,5.284614575787872A84.375,84.375,0,0,0,82.19101849740879,-19.072941654569345Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M243.39518632145078,21.861470685803603A244.375,244.375,0,0,1,224.46458752059328,96.6167147765329L77.93073711601922,32.34100860446231A84.375,84.375,0,0,0,83.93065643919559,8.647863012659043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M223.1089558420525,99.70724370911613A244.375,244.375,0,0,1,180.93108102395774,164.26528709530214L63.207126495357564,55.89275252839018A84.375,84.375,0,0,0,76.57510543747838,35.431537537045564Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M178.64540810502677,166.74818975925479A244.375,244.375,0,0,1,117.79088446339424,214.1131667187502L41.63404295930516,73.38764945045406A84.375,84.375,0,0,0,60.92145357642656,58.37565519234283Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M114.8228584307087,215.71938208422864A244.375,244.375,0,0,1,41.886217857333584,240.75856242013074L15.54926484987392,82.92985582785295A84.375,84.375,0,0,0,38.66601692661969,74.99386481593251Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M38.55747038520403,241.3140321292861A244.375,244.375,0,0,1,-38.557470385204,241.3140321292861L-12.2205173777444,83.48532553700828A84.375,84.375,0,0,0,12.22051737774441,83.48532553700828Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M-41.886217857333556,240.75856242013074A244.375,244.375,0,0,1,-114.82285843070873,215.7193820842286L-38.66601692661968,74.99386481593251A84.375,84.375,0,0,0,-15.549264849873907,82.92985582785295Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M-117.79088446339415,214.11316671875022A244.375,244.375,0,0,1,-178.64540810502677,166.74818975925479L-60.92145357642656,58.37565519234284A84.375,84.375,0,0,0,-41.634042959305155,73.38764945045408Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01A0C6",
    d: "M-180.93108102395766,164.26528709530226A244.375,244.375,0,0,1,-223.10895584205244,99.70724370911621L-76.57510543747837,35.4315375370456A84.375,84.375,0,0,0,-63.20712649535752,55.892752528390226Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E58A6",
    d: "M-224.46458752059326,96.61671477653302A244.375,244.375,0,0,1,-243.39518632145078,21.86147068580366L-83.93065643919559,8.647863012659073A84.375,84.375,0,0,0,-77.9307371160192,32.34100860446234Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E58A6",
    d: "M-243.6738730324388,18.49822224893255A244.375,244.375,0,0,1,-237.30577169748085,-58.35333190198402L-82.19101849740879,-19.072941654569313A84.375,84.375,0,0,0,-84.20934315018359,5.284614575787899Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E58A6",
    d: "M-236.47731341151058,-61.62483968883163A244.375,244.375,0,0,1,-205.50059453165292,-132.244645532956L-71.54470837637447,-44.72689714634284A84.375,84.375,0,0,0,-81.36256021143853,-22.34444944141698Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E58A6",
    d: "M-203.6547675588641,-135.0698940384016A244.375,244.375,0,0,1,-151.42623927805624,-191.80519983333312L-53.145418972228775,-65.53399932299467A84.375,84.375,0,0,0,-69.69888140358562,-47.552145651788486Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E58A6",
    d: "M-148.7630676119068,-193.87802954356442A244.375,244.375,0,0,1,-80.94250137848994,-230.58068456744846L-28.98699878630154,-79.23947580822927A84.375,84.375,0,0,0,-50.48224730607952,-67.60682903322584Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E58A6",
    d: "M-77.75058099237339,-231.67647222009484A244.375,244.375,0,0,1,-1.6873875022501013,-244.36917430072324L-1.6873875022499583,-84.3581255624925A84.375,84.375,0,0,0,-25.795078400185208,-80.33526346087562Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "about",
    transform: "translate(214, 377)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "play",
    transform: "translate(160, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73.3909,
    cy: 70.0969,
    r: 62,
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(34, 35)",
    d: "M55.7821 39.228L27.1486 55.842C24.7186 57.2505 21.6001 55.545 21.6001 52.7055V19.4775C21.6001 16.6425 24.7141 14.9325 27.1486 16.3455L55.7821 32.9595C56.3349 33.2751 56.7943 33.7312 57.1139 34.2817C57.4335 34.8321 57.6019 35.4573 57.6019 36.0938C57.6019 36.7303 57.4335 37.3555 57.1139 37.9059C56.7943 38.4563 56.3349 38.9125 55.7821 39.228Z",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 38)",
    d: "M54.156 52.286L20.206 52.286L13.513 68H0.515L31.07 0.0999954L43.486 0.0999954L74.138 68H60.946L54.156 52.286ZM49.985 42.392L37.181 12.71L24.474 42.392L49.985 42.392ZM130.885 32.692C134.636 33.9207 137.611 35.99 139.809 38.9C142.008 41.7453 143.107 45.302 143.107 49.57C143.107 55.4547 140.844 60.0137 136.317 63.247C131.791 66.4157 125.195 68 116.529 68H82.7733L82.7733 0.0999954L114.589 0.0999954C122.608 0.0999954 128.784 1.68433 133.116 4.853C137.449 7.957 139.615 12.2573 139.615 17.754C139.615 21.1167 138.839 24.0913 137.287 26.678C135.735 29.2647 133.601 31.2693 130.885 32.692ZM95.3833 9.994L95.3833 28.715L113.231 28.715C117.629 28.715 120.991 27.939 123.319 26.387C125.712 24.7703 126.908 22.4423 126.908 19.403C126.908 16.299 125.712 13.971 123.319 12.419C120.991 10.8023 117.629 9.994 113.231 9.994L95.3833 9.994ZM115.753 58.106C125.518 58.106 130.4 54.8403 130.4 48.309C130.4 41.7777 125.518 38.512 115.753 38.512H95.3833V58.106H115.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(325, 38)",
    d: "M30.315 68.97C20.9383 68.97 13.631 66.351 8.393 61.113C3.155 55.8103 0.536001 48.2443 0.536001 38.415V0.0999954H13.146V37.93C13.146 51.2513 18.9013 57.912 30.412 57.912C41.858 57.912 47.581 51.2513 47.581 37.93V0.0999954H59.997V38.415C59.997 48.2443 57.378 55.8103 52.14 61.113C46.9667 66.351 39.6917 68.97 30.315 68.97ZM90.1996 10.77H67.6956V0.0999954H125.314V10.77H102.81V68H90.1996V10.77Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.1e297f4e6d7b2cbdc62d78ae1444e925.svg";
export { ForwardRef as ReactComponent };